// Logique MIME partagée pour les pièces jointes (icône par type, isImage/isPdf, nom de téléchargement).
// Extraite de EmailAttachement pour être réutilisée par DisplayAttachment (variante CustomView, sans preview
// inline) SANS dupliquer les tables MIME. EmailAttachment re-exporte les enums pour compat des imports existants.

export enum imageMimeTypes {
    gif = "image/gif",
    jpeg = "image/jpeg",
    png = "image/png",
    bmp = "image/bmp",
    webp = "image/webp",
    svg = "image/svg+xml",
}

export enum documentMimeTypes {
    pdf = "application/pdf",
    doc = "application/msword",
    docx = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls = "application/vnd.ms-excel",
    xlsx = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ppt = "application/vnd.ms-powerpoint",
    pptx = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    txt = "text/plain",
    csv = "text/csv",
    rtf = "application/rtf",
    code = "text/x-csrc",
    video = "video/mp4",
    folder = "inode/directory",
    mail = "message/rfc822",

    // Images types
    gif = imageMimeTypes.gif,
    jpeg = imageMimeTypes.jpeg,
    png = imageMimeTypes.png,
    bmp = imageMimeTypes.bmp,
    webp = imageMimeTypes.webp,
    svg = imageMimeTypes.svg,
}

const mimeTypeToExtension: Record<string, string> = {
    [documentMimeTypes.pdf]: "pdf",
    [documentMimeTypes.doc]: "doc",
    [documentMimeTypes.docx]: "docx",
    [documentMimeTypes.xls]: "xls",
    [documentMimeTypes.xlsx]: "xlsx",
    [documentMimeTypes.ppt]: "ppt",
    [documentMimeTypes.pptx]: "pptx",
    [documentMimeTypes.txt]: "txt",
    [documentMimeTypes.csv]: "csv",
    [documentMimeTypes.rtf]: "rtf",
    [documentMimeTypes.video]: "mp4",
    [documentMimeTypes.mail]: "eml",
    [imageMimeTypes.gif]: "gif",
    [imageMimeTypes.jpeg]: "jpg",
    [imageMimeTypes.png]: "png",
    [imageMimeTypes.bmp]: "bmp",
    [imageMimeTypes.webp]: "webp",
    [imageMimeTypes.svg]: "svg",
};

export const isImageType = (type: string): boolean =>
    Object.values(imageMimeTypes).includes(type as imageMimeTypes);

export const isPdfType = (type: string): boolean =>
    type === documentMimeTypes.pdf;

export const isDocumentType = (type: string): boolean =>
    Object.values(documentMimeTypes).includes(type as documentMimeTypes);

// Ajoute l'extension déduite du type MIME si le nom ne la porte pas déjà.
export const getDownloadName = (name: string, type: string): string => {
    const extension = mimeTypeToExtension[type];
    if (!extension) return name;
    const alreadyHasExtension = name.toLowerCase().endsWith(`.${extension}`);

    return alreadyHasExtension ? name : `${name}.${extension}`;
};
